<div class="posts-sidebar" *ngIf="recommendedBlogs$ | async; else elseBlock">
  <div
    class="widget latest-post-widget wow fadeInUp"
    data-wow-delay="0.3s"
    data-wow-duration="1200ms"
  >
    <h2 class="">Most Recent Blogs</h2>
    <br />
    <br />
    <div class="popular-posts-wrapper">
      <!-- Data -->
      <!-- <marquee height="500" width="100%" behavior="scroll" direction="up" scrollamount="3" onmouseover="this.stop();" onmouseout="this.start();"> -->

      <div
        class="popular-posts-item"
        *ngFor="let item of recommendedBlogs$ | async | slice : 0 : 4"
      >
        <div class="popular-posts-thumbnail blog-image">
          <img
            src="{{ item['fieldCoverImage']['entity']['url'] }}"
            [alt]="item['fieldCoverImage']['alt']"
            class=""
            style="height: 75px; width: 105px"
            (error)="$event.target.src = defaultImage"
          />
        </div>
        <div class="popular-posts-item-content mb-4">
          <p class="lh-base fw-normal d-flex flex-column">
            <a
              class="blog-link"
              routerLink="{{ item.path.alias }}"
              [attr.title]="item.title"
              (mousedown)="loader($event)"
            >
              {{ item.title }}</a
            >

            <a class="blog-link" href="javascript:void(0)" class="posts-date"
              ><i class="far fa-calendar-alt"></i>
              <small class="mr-5">
                {{
                  item["publishedAt"]["value"] * 1000 | date : "MMMM dd,yyyy"
                }} </small
              >/
              <small class="fw-normal">
                <a
                  [routerLink]="['/blogs']" [queryParams]="{tags: item.fieldBlogMainCategory.entity.name.replace(' ', '-')}"
                  >{{ item.fieldBlogMainCategory.entity.name }}</a
                ></small
              ></a
            >
          </p>
        </div>
      </div>
      <!-- </marquee> -->
      <div class="row icon-boxes-v3 justify-content-center">
        <div class="iconic-box have-icon-overly color-v4">
          <a href="/blogs" class="explore-btn"
            >All Blogs &nbsp;&nbsp;<i
              class="far fa-arrow-right"
              style="font-weight: bolder"
            ></i
          ></a>
        </div>
      </div>
      <!-- Data -->
    </div>
  </div>
</div>
<ng-template #elseBlock>
  <div class="posts-sidebar">
    <div
      class="widget latest-post-widget wow fadeInUp"
      data-wow-delay="0.3s"
      data-wow-duration="1200ms"
    >
      <h2 class="">Most Recent Blogs</h2>
      <div class="ph-item dark-preloader">
        <div class="ph-col-12">
          <div class="ph-row" *ngFor="let _loading of loadingArray">
            <div class="ph-col-12"></div>
            <div class="ph-col-6"></div>
            <div class="ph-col-2 empty"></div>
            <div class="ph-col-4"></div>
            <div class="ph-col-12 empty"></div>
            <div class="ph-col-12 empty"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div *ngIf="loading">
  <div
    class="loading2"
    style="
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    "
  ></div>
</div>
